import React, {PureComponent} from 'react';
import './TextInput.scss';

export class TextInput extends PureComponent {

    static defaultProps = {
        type: 'text'
    };

    constructor() {
        super(...arguments);

        this.state = {
            value: '',
            valid: true
        };
    }

    onChange = ({target}) => {
        const {value} = target;

        this.setState({
            value,
            valid: value === '' || target.checkValidity()
        });

        this.props.onChange && this.props.onChange(value);
    };

    render = () => {
        const {type, label, message, ...rest} = this.props;
        const {value, valid} = this.state;

        return (
            <div className={`form-element ${!valid ? 'form-element-invalid' : ''}`} data-content={!!value} >
                <label className="form-element-label">
                    <span className="form-element-label-text">{label}</span>
                    <input type={type} {...rest} className="form-element-input" onChange={this.onChange}/>
                </label>
                {message && <span className="form-element-message">{message}</span>}
            </div>
        );
    };
}



// WEBPACK FOOTER //
// /Users/stephan/skelware/savot/src/components/TextInput/TextInput.jsx